import React from 'react';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import Styles from './styles.js';
import Link from 'next/link';
import { Grid, Row, Col } from 'rsuite';
const WhyChooseSoulrooms = ({
  title,
  spacing,
  card1hd,
  card1txt,
  smallsize,
  card2hd,
  card2txt,

  card1Img,
  card2Img,
}) => {
  return (
    <>
      {title ? <HeadingSection title={title} bgcolor="white" /> : null}
      <div className="lg:container  px-4 px-lg-0 mx-auto">
        <div className="row row-custom gx-md-5 gx-lg-5 mx-lg-1 mx-xxl-2 px-md-3 px-lg-2 mx-xl-0 px-xl-0 px-xxl-4">
          <Grid>
            <Row>
              <Col xs={24} md={12} >
                <div className="  col-md-6 ps-0 ">
                  <div className=" card bg-transparent border-0">
                    <div
                      className="card-title text-center d-flex justify-content-center align-items-center"
                      style={{ minHeight: '70px' }}>
                      <h4 className=" fs-responsive fw-normal  " style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
                        {card1hd}
                      </h4>
                    </div>
                    <img loading="lazy" src={card1Img} className=" img img-fluid rounded-0 card-img-top" alt="..." />
                    <div className={spacing ? 'card-body p-0 ' : 'card-body p-0 pb-4'}>
                      <div
                        className={spacing ? ' custom  mt-4   pb-3 text-center' : ' custom  mt-4 mb-4 pb-3 text-center'}
                        style={{ fontFamily: 'josefin Sans' }}>
                        <p
                          className={smallsize ? 'fs-18-27 min-height-exp  mt-2 ' : 'fs-20 min-height-exp  mt-2 '}
                          style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e' }}>
                          {card1txt}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} md={12} >
                <div className=" col-md-6 pe-0 ">
                  <div className="card bg-transparent border-0">
                    <div
                      className="card-title text-center d-flex justify-content-center align-items-center"
                      style={{ minHeight: '70px' }}>
                      <h4 className=" fs-responsive fw-normal  " style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
                        {card2hd}
                      </h4>
                    </div>
                    <img loading="lazy" src={card2Img} className=" img img-fluid rounded-0 card-img-top" alt="..." />
                    <div className={spacing ? 'card-body p-0 ' : 'card-body p-0 pb-4'}>
                      <div
                        className={spacing ? ' custom  mt-4   pb-3 text-center' : ' custom  mt-4 mb-4 pb-3 text-center'}
                        style={{ fontFamily: 'josefin Sans' }}>
                        <p
                          className={smallsize ? 'fs-18-27 min-height-exp  mt-2 ' : 'fs-20 min-height-exp  mt-2 '}
                          style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e' }}>
                          {card2txt}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
      </div>
      <Styles/>
    </>
  );
};

export default WhyChooseSoulrooms;
